import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=ca1523e6&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=ca1523e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../CarbonManagement.Web/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1523e6",
  null
  
)

export default component.exports